export const CHECKLIST_SUBMIT_STATUS = {
  DRAFT: "draft",
  SUBMITTED: "submitted",
} as const;

export type ChecklistSubmitStatus =
  | (typeof CHECKLIST_SUBMIT_STATUS)[keyof typeof CHECKLIST_SUBMIT_STATUS]
  | null;

/** Reads submit status from saved checklist JSON. Legacy saves without a flag count as submitted. */
export function readChecklistSubmitStatus(
  savedJson: unknown
): ChecklistSubmitStatus {
  if (!savedJson || typeof savedJson !== "object") return null;
  const status = (savedJson as Record<string, unknown>).checklistSubmitStatus;
  if (status === CHECKLIST_SUBMIT_STATUS.DRAFT) {
    return CHECKLIST_SUBMIT_STATUS.DRAFT;
  }
  if (status === CHECKLIST_SUBMIT_STATUS.SUBMITTED) {
    return CHECKLIST_SUBMIT_STATUS.SUBMITTED;
  }
  return CHECKLIST_SUBMIT_STATUS.SUBMITTED;
}

export function isChecklistSubmittedStatus(
  status: ChecklistSubmitStatus
): boolean {
  return status === CHECKLIST_SUBMIT_STATUS.SUBMITTED;
}
